/** Brand color palette for FIG K-12 */

export const brand = {
  teal: '#1ebec8',
  green: '#86c65a',
  orange: '#f79153',
  red: '#fa4747',
  black: '#000000',
  white: '#ffffff',
} as const;

export const neutrals = {
  text: '#36454f',
  textSecondary: '#606060',
  background: '#f9f9f9',
  card: '#f1f6fc',
  border: '#dddddd',
  inputBorder: '#bbbbbb',
  newBorder: '#dadada',
  stepIcon: '#d9d9d9',
  cancelBg: '#7f7f7f1f',
  cancelText: '#606060',
} as const;

export const lightPalette = {
  primary: {
    main: brand.teal,
    light: '#4dd0d8',
    dark: '#15969e',
    contrastText: brand.white,
  },
  secondary: {
    main: brand.green,
    light: '#a1d47e',
    dark: '#6aaa3e',
    contrastText: brand.white,
  },
  error: {
    main: brand.red,
    light: '#fb7272',
    dark: '#d63030',
    contrastText: brand.white,
  },
  warning: {
    main: brand.orange,
    light: '#f9ab7e',
    dark: '#e07530',
    contrastText: brand.white,
  },
  success: {
    main: brand.green,
    light: '#a1d47e',
    dark: '#6aaa3e',
    contrastText: brand.white,
  },
  text: {
    primary: neutrals.text,
    secondary: neutrals.textSecondary,
    disabled: '#a0a0a0',
  },
  background: {
    default: neutrals.background,
    paper: brand.white,
  },
  divider: neutrals.border,
} as const;

/** Dark palette - future-ready placeholder */
export const darkPalette = {
  ...lightPalette,
  background: {
    default: '#121212',
    paper: '#1e1e1e',
  },
  text: {
    primary: '#e0e0e0',
    secondary: '#a0a0a0',
    disabled: '#666666',
  },
  divider: '#333333',
} as const;
